<style lang="scss" scoped>
.articleLib {
  /deep/ {
    .el-dialog__body {
      padding: 10px 0 30px 0;
    }
  }
}
.form {
  width: 700px;
  margin: 40px auto 100px;
}
</style>

<template>
  <div>
    <div class="lib" @click="show">
      <slot></slot>
    </div>
    <el-dialog
      title="新建语音"
      :visible.sync="dialog"
      width="1000px"
      top="10vh"
      class="articleLib"
      :append-to-body="true"
    >
      <el-form ref="form" :model="form" label-width="100px" class="form" label-position="left">
        <el-form-item label="标题">
          <el-input type="text" v-model="form.title" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="语音内容">
          <div style="color:#9B9B9B">格式支持mp3、wma、wav、amr、m4a，文件大小不超过2M</div>
          <el-upload
            :show-file-list="false"
            style="display:inline-block"
            action
            :before-upload="beforeFn"
            :http-request="uploadVoice"
            accept="mp3, wma, wav, amr, m4a"
          >
            <el-button type="info">上传文件</el-button>
          </el-upload>
          <ul class="el-upload-list el-upload-list--text" v-if="Object.keys(file).length">
            <li tabindex="0" class="el-upload-list__item is-success">
              <a class="el-upload-list__item-name">
                <i class="el-icon-document"></i>
                {{file.name}}
              </a>
              <label class="el-upload-list__item-status-label">
                <i class="el-icon-upload-success el-icon-circle-check"></i>
              </label>
              <i class="el-icon-close" @click="del"></i>
            </li>
          </ul>
        </el-form-item>
      </el-form>
      <div class="alignc">
        <el-button type="primary" @click="save">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import utils from '@/utils.js';
export default {
  components: {},
  computed: {},
  computed: {
    id() {
      return this.$route.params.id;
    },
  },
  data() {
    return {
      form: {
        title: '',
        voiceurl: '',
      },
      radio: '',
      dialog: false,
      file: {},
    };
  },
  watch: {
    'form.title': {
      handler(val, oldval) {
        let iLen = utils.getStringLength(val);
        if (iLen > 50) {
          this.form.title = oldval;
        }
      },
    },
  },
  methods: {
    show() {
      this.dialog = true;
      this.form = {
        title: '',
        voiceurl: '',
      };
    },
    async save() {
      if (this.form.title && this.form.voiceurl) {
        let res = await this.$http.post(
          `/api/${this.id}/material/voice`,
          this.form,
        );
        console.log(res);
        this.$emit('confirm', res.material);
        this.dialog = false;
      } else {
        this.$message.error(`请完善信息`);
      }
      // let data = Object.assign({}, this.form);
      // this.$emit('confirm', data);
      // this.dialog = false;
    },
    err(err) {
      console.log(err);
    },
    del() {
      this.file = {};
      this.form.voiceurl = '';
    },
    async uploadVoice(file, fileList) {
      let fd = new FormData();
      fd.append('File', file.file);
      fd.append('Type', '4');
      let res = await this.$http.post(
        `/api/${this.id}/material/file/upload`,
        fd,
      );
      console.log(res);
      this.file = res;
      this.form.voiceurl = res.url;
      return;
    },
    beforeFn(file) {
      if (file.size > 2048 * 1024) {
        this.$message.error(`音频大小不能超过2mb`);
        return false;
      }
      return true;
    },
  },
  mounted() {},
};
</script>
